import React from "react";
import "./BlogCards.css";
import { blogData } from "../data/blogData";
import { useNavigate } from "react-router-dom";

const BlogCards = () => {
  const navigate = useNavigate();

  return (
    <div className="blog-container">
      {blogData.map((post, index) => (
        <div
          key={index}
          className="blog-card"
          onClick={() => navigate(`/blog/${index}`)} // 👈 al hacer clic navega al detalle
          style={{ cursor: "pointer" }}
        >
          <div className="meta">
            <div
              className="photo"
              style={{ backgroundImage: `url(${post.image})` }}
            ></div>
            <ul className="details">
              <li className="author">
                <p>{post.author}</p>
              </li>
              <li className="author">
                <p>{post.position}</p>
              </li>
              <li className="date">{post.date}</li>
            </ul>
          </div>
          <div className="description">
            <h1>{post.title}</h1>
            <h2>{post.subtitle}</h2>
            <p>{post.description}</p>
            <p className="read-more">
              <p>Leer Más</p>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlogCards;
